import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { Appointment, Schedule } from '../../appointment/model/appointment';
import { AppointmentService } from '../../appointment/service/appointment.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent implements OnInit {
 
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  appointments : Appointment[];
  selectedAppObject : Appointment;
  isSuccessMessage : boolean = false;
  isErrorMessage : boolean = false;
  apploading : boolean = false;
  isAdd : boolean = true;
  userClinic= null;
  appDate: any;
  id: number;
  private sub: any;
  user : any ; 
  schedulrloading : boolean = false;
  startDate: string ="";
  endDate: string = ""; 
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  start: Object  = {};
  end: Object  = {};
  option: string = '0';
  constructor(private _sharedService: SharedService,private _appService : AppointmentService) { 
    let d = new Date();
    this.start =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
    this.end =  d.getFullYear() + '-' + (d.getMonth() + 1) + '-'+ d.getDate();
   }


  ngOnInit() {
    //this.getCompletedAppointment();
  }
  getCompletedAppointment() : void {
    this.apploading = true;
     this._appService.getCompletedAppointment().subscribe(data=>{
       this.appointments = data;
       this.apploading = false;
     },error=>{

     });
  }

  showAppointmentList() : void {
    this.apploading = true;
     this._appService.getAllAppointmentsForDoc(this.startDate, this.endDate).subscribe(data=>{
       this.appointments = data.filter(item=> parseInt(this.option) !== 0 ?item.Status== parseInt(this.option) : item);
       this.apploading = false;
     },error=>{

     });
  }

  showAppointment(appId: number) {
    window.open("https://www.theaurapower.com/Patient/DoctorPrescription?AppointmentId="+appId,"_blank","width:100%");
  }
  showHistory(appId: number) {
    window.open("https://www.theaurapower.com/Patient/History?AppointmentId="+appId,"_blank","width:100%");
  }
  onDateChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.startDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.startDate="";
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
  onDateEndChanged(event: IMyDateModel) {
    //debugger;
    
    if(event.date != null && event.date.year != 0) {
      this.endDate= event.date.year + '-' + event.date.month + '-'+ event.date.day;
    }
    else {
      this.endDate = "";
      //this.message = 'Please select appointment date!'; 
      //this.isErrorMessage = true;
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/section/appointment/complete/complete.component.ts